import type { IUpdateOfficeRequest } from '../types/UpdateOffice';
import type {
  IAddAddressApiPayload,
  IUpdateOfficeInfoApiPayload,
  IUpdateUserEducationApiPayload,
} from '../types/UpdateOffice.api';

const ADDRESS_DISTANCE_MILES = 25;

const toUpdateOfficeInfoPayload = (
  input: IUpdateOfficeRequest,
): IUpdateOfficeInfoApiPayload => ({
  office_name: input.officeName,
  office_info: { officeType: input.officeType },
});

const toAddAddressPayload = (placeId: string): IAddAddressApiPayload => ({
  place_id: placeId,
  distance: ADDRESS_DISTANCE_MILES,
});

const toUpdateUserEducationPayload = (
  input: IUpdateOfficeRequest,
): IUpdateUserEducationApiPayload => ({
  education: {
    specialtiesAndProcedures: { [input.officeSpecialty]: [] },
  },
  insurances: [],
});

export const UpdateOfficeAdapters = {
  toUpdateOfficeInfoPayload,
  toAddAddressPayload,
  toUpdateUserEducationPayload,
};
